import { render, staticRenderFns } from "./import.vue?vue&type=template&id=40373aaf&scoped=true&"
import script from "./import.vue?vue&type=script&lang=js&"
export * from "./import.vue?vue&type=script&lang=js&"
import style0 from "./import.vue?vue&type=style&index=0&id=40373aaf&prod&scoped=true&lang=css&"
import style1 from "./import.vue?vue&type=style&index=1&id=40373aaf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40373aaf",
  null
  
)

export default component.exports